import { NX_ENV, NX_PUBLIC_DASHBOARD_URL } from './env-from-process';
export var environment = {
    env: NX_ENV !== null && NX_ENV !== void 0 ? NX_ENV : 'development',
    production: true,
    apiUrl: 'https://authn.zephyrcloudapp.xyz',
    dashboardUrl: NX_PUBLIC_DASHBOARD_URL !== null && NX_PUBLIC_DASHBOARD_URL !== void 0 ? NX_PUBLIC_DASHBOARD_URL : 'https://stg.zephyr-cloud.io'
};
